import { jsx as e } from "react/jsx-runtime";
import { HeaderLogoContainer as g } from "./style.js";
import { ReactComponent as p } from "../../resources/graphics/brand/logo.svg.js";
import { ReactComponent as l } from "../../resources/graphics/brand/logoPromoNinja.svg.js";
import { ReactComponent as c } from "../../resources/graphics/brand/logo-black-friday.svg.js";
function S({
  url: r,
  className: a,
  locale: n,
  onClick: t,
  isBlackFridayLogo: m
}) {
  const i = m ? c : p;
  let o;
  return n === "en-US" ? o = l : o = i, /* @__PURE__ */ e(g, { url: r, className: a, onClick: t, children: /* @__PURE__ */ e(o, { role: "img", "aria-label": "Pelando" }) });
}
export {
  S as HeaderLogo
};
